import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from './lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded px-2 py-0.5 text-[11px] font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:      'bg-surface text-text-dark border border-nn-border',
        primary:      'bg-aqua text-white',
        secondary:    'bg-royal text-white',
        success:      'bg-green-bg text-green-nn border border-green-nn/30',
        warning:      'bg-yellow-bg text-yellow-nn border border-yellow-nn/30',
        danger:       'bg-red-bg text-red-critical border border-red-critical/30',
        outline:      'bg-transparent border border-nn-border text-text-dark',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
));
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
